import { EmptyShaderColor as EmptyFileColorIcon } from 'patternx-svg';
import './index.less';
interface Props {
  onCreate: () => void;
}

const EmptyInfo: React.FC<Props> = (props: Props) => {
  const { onCreate } = props;

  return (
    <div className="list-empty-wrap">
      <EmptyFileColorIcon size={200} />
      <div className="list-empty-title" style={{ marginTop: 8 }}>
        暂无材质
      </div>
      <div className="list-empty-fn" style={{ marginTop: 12 }}>
        <div className="list-empty-createMaterial" onClick={onCreate}>
          新增材质
        </div>
      </div>
    </div>
  );
};

export default EmptyInfo;
